// DTM
import React from "react";
import styled from "styled-components";

import scale from "../helper/scaling";
import ArticleAbstract from "./ArticleAbstract";

const Wrapper = styled.div`
  width: 100%;
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 80px 0;
  @media (max-width: 1100px) {
    width: calc(100% - 50px);
    padding: 25px;
  }
  @media (max-width: 700px) {
    width: 100%;
    padding: 0;
  }
`;

const Inner = styled.div`
  width: 1040px;
  position: relative;
  float: left;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  @media (max-width: 1100px) {
    width: 100%;
  }
`;
const BlueBox = styled.div`
  background-color: rgba(57, 73, 171, 0.9);
  float: left;
  width: 100%;
  @media (max-width: 1100px) {
    overflow-x: hidden;
  }
`;
const Title = styled.div`
  font-family: Lato;
  font-size: 36px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.69;
  letter-spacing: 0.4px;
  text-align: center;
  color: rgba(255, 255, 255, 0.85);

  @media (max-width: 1100px) {
    font-size: ${scale(1100, 767, 36, 21, "vw")};
    line-height: ${scale(1100, 767, 36 * 1.69, 21 * 1.43, "vw")};

    letter-spacing: 0.3px;
  }
  @media (max-width: 800px) {
    line-height: 1.43;
  }
  @media (max-width: 700px) {
    font-size: 16px;
    line-height: 1.38;
    letter-spacing: 0.2px;
    margin: 0 14px;
    width: calc(100% - 28px);
  }
`;
const Body = styled.div`
  margin: 0 40px;

  font-family: Lato;
  font-size: 18px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: 1.3px;
  text-align: center;
  color: rgba(255, 255, 255, 0.85);

  @media (max-width: 1100px) {
    font-size: ${scale(1100, 767, 18, 14, "vw")};

    line-height: ${scale(1100, 767, 18 * 1.67, 14 * 1.29, "vw")};
    letter-spacing: 1px;
  }
  @media (max-width: 800px) {
    line-height: 1.29;
  }
  @media (max-width: 700px) {
    font-size: 12px;
    line-height: 1.5;
    letter-spacing: 0.8px;
    margin: 0 14px;
    width: calc(100% - 28px);
  }
`;
const BorderBox = styled.div`
  width: calc(100% - 70px);
  margin: 32px;
  padding: ${props => (props.thin ? "25" : "100")}px 0;
  border: solid 3px #ffffff;
  float: left;

  @media (max-width: 1100px) {
    width: ${scale(1050, 717, 980, 675)};
    margin: ${scale(1100, 767, 32, 18, "vw")};
  }
  @media (max-width: 700px) {
    border: solid 2px #ffffff;
    margin: 23px;
    width: calc(100% - 50px);
  }
`;

class ArticleBlueBox extends ArticleAbstract {
  // image
  // title
  // body
  render() {
    return (
      <Wrapper>
        <Inner style={this.image()}>
          <BlueBox>
            <BorderBox thin={this.props.thin}>
              <Title>{this.title()}</Title>
              <Body>{this.props.children || this.body()}</Body>
            </BorderBox>
          </BlueBox>
        </Inner>
      </Wrapper>
    );
  }
}

export default ArticleBlueBox;



// WEBPACK FOOTER //
// ./src/components/ArticleBlueBox.js